import { format } from "date-fns"

import { handleRoundNumber } from "./handleRoundNumber"

export const formatMetersToDistance = (value, significantNumber = 0) => {
    if (value < 1000) {
        const valueInMeters = handleRoundNumber(value, 0)
        return `${valueInMeters} m`
    } else {
        return `${handleRoundNumber(value / 1000, significantNumber)} km`
    }
}

export const formatMetersToKilometers = (value) => {
    return `${Math.floor((value / 1000))} km`
}

export const formatHoursToTime = (value) => {
    const hours = value.getHours()
    return hours >= 10 ? hours : `0${hours}`
}

export const formatSecondsToTime = (value) => {
    const minutes = value.getMinutes()
    return minutes >= 10 ? minutes : `0${minutes}`
}

export const formatHoursAndMinutesToTime = (value) => {
    return `${formatHoursToTime(value)}:${formatSecondsToTime(value)}`
}

const THOUSAND = { value: Math.pow(10, 3), unit: "k" }
const MILLION = { value: Math.pow(10, 6), unit: "m" }
const BILLION = { value: Math.pow(10, 9), unit: "M" }

export function formatNumber(num, significantNumber = 0) {
    const number = typeof num === "string" ? parseFloat(num) : num
    if (!(typeof number === "number")) {
        return null
    }
    const roundedNumber = handleRoundNumber(parseFloat(number), significantNumber)
    const numString = roundedNumber.toString().split(".")

    return [...numString[0]].reverse().reduce((acc, v, index) => {
        return index > 0 && index % 3 === 0 ? `${v} ${acc}` : `${v}${acc}`
    }, "").concat(numString[1] ? `.${numString[1]}` : "")
}

export function parseFormattedNumber(formattedNumber = "0") {
    const stringNumber = formattedNumber.toString()
    if (typeof stringNumber !== "string") {
        return null
    }
    return parseFloat(stringNumber.replaceAll(" ", "").replaceAll(",", "."))
}

export function formatNumberWithUnit(number, significantNumber = 1) {

    const value = typeof numOrString === "number" ? number : parseFloat(number)

    if (isNaN(value)) {
        throw new Error("Invalid number")
    }

    if (value >= BILLION.value) {
        return `${+(value / BILLION.value).toFixed(significantNumber)} ${BILLION.unit}`
    } else if (value >= MILLION.value) {
        return `${+(value / MILLION.value).toFixed(significantNumber)} ${MILLION.unit}`
    } else if (value >= THOUSAND.value) {
        return `${+(value / THOUSAND.value).toFixed(significantNumber)} ${THOUSAND.unit}`
    } else {
        return `${+value.toFixed(1)} `
    }
}

export function formatDate(dateString, stringFormat = "dd.MM.yy") {
    if (dateString) {
        return format(new Date(dateString), stringFormat)
    } else {
        return ""
    }
}